import { f7, useStore } from 'framework7-react';
import { Router } from 'framework7/types';
import { FC, useEffect, useState } from 'react';
import { findRelevantNextWarranty } from '../WarrantyManagement/WarrantyManagementHelper';
import { Payments } from './Payments/Payments';
import { makePayment } from './paymentsHelper';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { Prepaid } from '@/types/api/customerApi';
import { PaymentMethod } from '@/types/payment';
import { paymentStorage } from '@/utils/paymentStorage';
import { storeDispatch } from '@/utils/store';
import { f7CustomBack } from '@/utils/utils';
import { getPreferredCurrentWarranty } from '@/utils/warranty';

interface PaymentsPageProps {
  f7router: Router.Router;
  popupOpened: boolean;
}

export const PaymentsPage: FC<PaymentsPageProps> = ({
  f7router,
  popupOpened,
}) => {
  const [isPopupOpened, setIsPopupOpened] = useState<boolean>(false);
  const paymentMethods = useStore(
    store,
    'getPaymentMethodsInfo',
  ) as Required<PaymentMethod>[];
  const {
    carsInfo,
    carItemInfo: car,
    advancePaymentsInfo,
    billsInfo: bills,
    // warranties,
  } = store.state;

  const handleClickWarranty = async (mCarId?: number) => {
    const carInfo = carsInfo.find((c) => mCarId === c.m_car_id);
    if (!carInfo) {
      f7.view.main.router.navigate(paths.warranty('false'));
      return;
    }
    await storeDispatch('setCarItemInfo', 'carItemInfo', carInfo);
    await storeDispatch('setWarranties', 'warranties', carInfo?.warranties);
    await storeDispatch(
      'setNextWarranties',
      'nextWarranties',
      carInfo?.next_warranty,
    );
    const preferredWarranty = getPreferredCurrentWarranty(carInfo.warranties);
    await storeDispatch(
      'setCurrentWarranty',
      'currentWarranty',
      preferredWarranty,
    );
    await storeDispatch(
      'setNextWarranty',
      'nextWarranty',
      findRelevantNextWarranty(preferredWarranty, carInfo?.next_warranty),
    );
    f7.view.main.router.navigate(paths.warranty('false'));
  };

  const handleClickBack = () => {
    const postGmoNav = paymentStorage.getItem('postGmoNav');
    if (postGmoNav) {
      // GMOリダイレクト後の遷移: F7がDOM上の古い.page-previousを優先するため、
      // f7CustomBack()ではなくnavigate()で/account/に遷移する。
      paymentStorage.removeItem('postGmoNav');
      f7.view.main.router.navigate(paths.account, {
        transition: 'push-reverse',
      });
      // navigate()後のF7履歴から古いエントリを全削除して循環を防ぐ。
      // F7はnavigate()後に非同期でlocalStorageに履歴を保存するため、
      // 遅延してsplice + localStorage同期を行う。
      setTimeout(() => {
        const history = f7.view.main.router.history;
        if (history.length > 1) {
          history.splice(0, history.length - 1);
        }
        window.localStorage.setItem(
          'f7router-view_main-history',
          JSON.stringify(history),
        );
      }, 0);
    } else if (f7.view.main.router.history.length > 1) {
      f7CustomBack();
    } else {
      f7.view.main.router.navigate(paths.account, {
        transition: 'push-reverse',
      });
    }
  };

  const prepaid = advancePaymentsInfo?.[0] ?? ([] as Prepaid[]);
  const paymentMethodList = makePayment(
    paymentMethods,
    carsInfo,
    bills,
    prepaid,
  );

  useEffect(() => {
    setTimeout(() => {
      setIsPopupOpened(popupOpened);
    }, 400);
  }, [popupOpened]);

  return (
    <Payments
      isPopupOpened={isPopupOpened}
      f7router={f7router}
      paymentList={paymentMethodList}
      hanldeClosePopup={() => setIsPopupOpened(false)}
      handleClickWarranty={handleClickWarranty}
      handleClickBack={handleClickBack}
    />
  );
};
